class MealOverviewModalController {
  constructor() {
    this.currentHandle = null;
    this.isInit = true;
    this.displayButtons = false;
    this.mealData = null;

    this.containerEl = document.querySelector('#meal-overview-modal-container');
    this.closeBtn = document.querySelector('#meal-overview-modal-close-btn');
    this.loaderEl = document.querySelector('#meal-overview-modal-loader');

    this.reviewTextEl = document.querySelector('#meal-overview-modal-rating-text');
    this.ratingsStarContainer = document.querySelector('#meal-overview-modal-rating-stars');

    this.galleryImage = document.querySelector('#meal-overview-primary-image');
    this.galleryThumbs = document.querySelector('#meal-overview-gallery-thumbs');
    this.titleEl = document.querySelector('#meal-overview-modal-product-title');
    this.descriptionEl = document.querySelector('#meal-overview-modal-description');
    this.drawerTitleElements = document.querySelectorAll('.meal-overview-modal-info-drawer-title');

    this.mealOverviewNutrientCarbsDesktopEl = document.querySelector('#meal-overview-modal-nutrient-desktop-carbs');
    this.mealOverviewNutrientFettDesktopEl = document.querySelector('#meal-overview-modal-nutrient-desktop-fett');
    this.mealOverviewNutrientProteinDesktopEl = document.querySelector('#meal-overview-modal-nutrient-desktop-protein');
    this.mealOverviewNutrientKcalDesktopEl = document.querySelector('#meal-overview-modal-nutrient-desktop-kcal');

    this.mealOverviewNutrientCarbsMobileEl = document.querySelector('#meal-overview-modal-nutrient-mobile-carbs');
    this.mealOverviewNutrientFettMobileEl = document.querySelector('#meal-overview-modal-nutrient-mobile-fett');
    this.mealOverviewNutrientProteinMobileEl = document.querySelector('#meal-overview-modal-nutrient-mobile-protein');
    this.mealOverviewNutrientKcalMobileEl = document.querySelector('#meal-overview-modal-nutrient-mobile-kcal');

    this.zutatenDrawer = document.querySelector('#meal-overview-modal-info-drawer-zutaten');
    this.zubereitungDrawer = document.querySelector('#meal-overview-modal-info-drawer-zubereitung');

    this.mealItemElements = document.querySelectorAll('.box-ingredient-meal-item');
  }

  async open(e) {
    const { handle, mealNutrients, mealInfoDrawerData, rating, reviewCount } = e.target.closest('.box-ingredient-meal-item').dataset;

    this.reviewTextEl.innerHTML = `${reviewCount} Bewertungen`;
    this.ratingsStarContainer.innerHTML = '';

    for (let i = 0; i < 5; i++) {
      const starElement = document.createElement('span');
      starElement.innerHTML = '★';

      if (i < rating) starElement.classList.add('active');

      this.ratingsStarContainer.appendChild(starElement);
    }

    if (this.displayButtons) {
      this.mealData = document.querySelector(`.meal-list-item__increase-quantity-button[data-handle="${handle}"]`).dataset;
      this.mealData.mealId = Number(this.mealData.mealId);
      this.mealData.quantity = Number(this.mealData.quantity);

      const buttons = document.querySelectorAll('.meal-overview-modal-add-to-cart-button');

      for (let i = 0; i < buttons.length; i++) {
        const button = buttons[i];

        button.addEventListener('click', () => {
          this.close();

          window.buildABox.addMealToBox({
            quantity: Number(this.mealData.quantity),
            title: this.mealData.title,
            mealId: Number(this.mealData.mealId),
            imageUrl: this.mealData.imageUrl
          });

          button.replaceWith(button.cloneNode(true));
        });
      }
    }

    $('html').addClass('disabled-scroll');

    window.addEventListener("wheel", this.preventScroll.bind(this));
    window.addEventListener("touchmove", this.preventScroll.bind(this));

    this.showLoader();
    this.containerEl.classList.add('active');

    const res = await fetch(`/products/${handle}.js`);
    const mealData = await res.json();

    let parsedNutrients;
    let parsedDrawerData;

    if (mealNutrients) {
      parsedNutrients = JSON.parse(mealNutrients);
    }

    if (mealInfoDrawerData) {
      parsedDrawerData = JSON.parse(mealInfoDrawerData);
    }

    this.populateModal({
      ...mealData,
      mealNutrients: parsedNutrients,
      drawerData: parsedDrawerData
    })

    this.hideLoader();
  }

  handleAddToBox() {

  }

  populateModal(mealData) {
    const { images, title, description, mealNutrients, drawerData } = mealData;

    this.galleryThumbs.innerHTML = '';

    console.log(drawerData);

    const defaultDrawerText = 'Kommt bald';

    this.zutatenDrawer.innerHTML = drawerData?.Zutaten || defaultDrawerText;
    this.zubereitungDrawer.innerHTML = drawerData?.Zubereitung || defaultDrawerText;

    for (let i = 0; i < this.drawerTitleElements.length; i++) {
      const drawerTitleEl = this.drawerTitleElements[i];

      if (this.isInit) {
        drawerTitleEl.addEventListener('click', () => {
          drawerTitleEl.parentElement.querySelector('.meal-overview-modal-info-drawer-content').classList.toggle('active');
        });
      }
    }

    images.forEach((image, i) => {
      const li = document.createElement('li');
      li.dataset.src = image;

      if (i === 0) li.classList.add('active');

      this.galleryThumbs.appendChild(li);

      li.addEventListener('click', () => {
        const { src } = li.dataset;
        const allThumbs = this.galleryThumbs.querySelectorAll('li');

        for (let i = 0; i < allThumbs.length; i++) {
          const thumbEl = allThumbs[i];
          thumbEl.classList.remove('active');
        }

        li.classList.add('active');
        this.galleryImage.src = src;
      })
    });

    this.titleEl.innerHTML = title;
    this.galleryImage.src = images[0];
    this.descriptionEl.innerHTML = description;

    if (mealNutrients) {
      this.mealOverviewNutrientKcalDesktopEl.innerHTML = mealNutrients.KCAL;
      this.mealOverviewNutrientCarbsDesktopEl.innerHTML = mealNutrients.CARBS;
      this.mealOverviewNutrientProteinDesktopEl.innerHTML = mealNutrients.PROTEIN;
      this.mealOverviewNutrientFettDesktopEl.innerHTML = mealNutrients.FETT;

      this.mealOverviewNutrientKcalMobileEl.innerHTML = mealNutrients.KCAL;
      this.mealOverviewNutrientCarbsMobileEl.innerHTML = mealNutrients.CARBS;
      this.mealOverviewNutrientProteinMobileEl.innerHTML = mealNutrients.PROTEIN;
      this.mealOverviewNutrientFettMobileEl.innerHTML = mealNutrients.FETT;
    }

    this.isInit = false;
  }

  showLoader() {
    this.loaderEl.classList.add('active');
  }

  hideLoader() {
    this.loaderEl.classList.remove('active');
  }

  close() {
    $('html').removeClass('disabled-scroll');

    window.removeEventListener("wheel", this.preventScroll.bind(this));
    window.removeEventListener("touchmove", this.preventScroll.bind(this));

    this.containerEl.classList.remove('active');

    for (let i = 0; i < this.drawerTitleElements.length; i++) {
      const drawerTitleEl = this.drawerTitleElements[i];
      drawerTitleEl.parentElement.querySelector('.meal-overview-modal-info-drawer-content').classList.remove('active');
    }
  }

  init() {
    if (this.containerEl.dataset.displayButtons) {
      const displayButtons = JSON.parse(this.containerEl.dataset.displayButtons);

      this.displayButtons = displayButtons === true;
    }

    this.closeBtn.addEventListener('click', () => {
      this.close();
    });

    for (let i = 0; i < this.mealItemElements.length; i++) {
      const mealItemEl = this.mealItemElements[i];

      mealItemEl.addEventListener('click', this.open.bind(this));
    }
  }

  preventScroll(e) {
    if (!this.isDescendant($('.custom-drawer-container'), e.target)) {
      e.preventDefault();
      return false;
    }

    let modalTop = modalEl.scrollTop === 0;
    let modalBottom = modalEl.scrollTop === (modalEl.scrollHeight - modalEl.clientHeight);

    if (modalTop && e.deltaY < 0) {
      e.preventDefault();
    } else if (modalBottom && e.deltaY > 0) {
      e.preventDefault();
    }
  }

  isDescendant(parent, child) {
    var node = child.parentNode;
    while (node != null) {
      if (node == parent) {
        return true;
      }
      node = node.parentNode;
    }
    return false;
  }

}